// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"_2aouy","checkbox":"_2i5dy","content":"IH_Ln","dot":"_34Mrk"};